import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/util';
import { IDocument } from '../modelviewer/types';
import { baseQueryCTMS as baseQuery } from './baseQuery';


export interface IStudyCountry { study_id: string, site_id: string, country: string }

export const studyApi = createApi({
    baseQuery: baseQuery,
    reducerPath: 'studyApi',
    endpoints: builder => ({
        getAllStudy: builder.query<string[], void>({
            query: () => ({
                url: endPoints.study.getAll.url
            }),
            keepUnusedDataFor: endPoints.study.getAll.keepUnusedDataFor
        }),
        getStudyCountry: builder.query<IStudyCountry, string>({
            query: (study_id) => ({
                url: formatString(endPoints.study.country.url, {
                    key: urlKeys.study_id,
                    value: study_id
                })
            }),
            keepUnusedDataFor: endPoints.study.country.keepUnusedDataFor
        }),
    })
});

export const { useGetAllStudyQuery, useGetStudyCountryQuery } = studyApi;
